import styled from 'styled-components'

export const CheckboxWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-weight: var(--font-light);
  font-size: 12px;
`
